// import { useState } from "react";
// import axios from "axios";
// import "./memberflyer.css";

// export default function MemberFlyerLogin() {
//   const [name,setName]=useState("")
//   const [mobile,setMobile]=useState("")
//   const [otp,setOtp]=useState("")
//   const [showOtp,setShowOtp]=useState(false)

//   const sendOtp=async()=>{
//     const res=await axios.post("https://api.lbnhyderabad.com/signup/api/memberflyer/send-otp",{name,mobile})
//     if(res.data.success){
//       setShowOtp(true)
//       alert("OTP sent")
//     }
//   }

//   const verifyOtp=async()=>{
//     const res=await axios.post("https://api.lbnhyderabad.com/signup/api/memberflyer/verify-otp",{mobile,otp})
//     if(res.data.success){
//       localStorage.setItem("memberflyer",JSON.stringify(res.data.user))
//       window.location="/memberflyer"
//     }
//   }

//   return(
//     <div className="loginContainer">

//       <div className="loginCard">

//         <h1 className="title">Member Flyer</h1>

//         {!showOtp && (
//         <>
//         <input
//         placeholder="Your Name"
//         value={name}
//         onChange={(e)=>setName(e.target.value)}
//         />

//         <input
//         placeholder="WhatsApp Mobile"
//         value={mobile}
//         onChange={(e)=>setMobile(e.target.value)}
//         />

//         <button onClick={sendOtp}>Send WhatsApp OTP</button>
//         </>
//         )}

//         {showOtp && (
//         <>
//         <input
//         placeholder="Enter OTP"
//         value={otp}
//         onChange={(e)=>setOtp(e.target.value)}
//         />

//         <button onClick={verifyOtp}>Verify WhatsApp OTP</button>
//         </>
//         )}

//       </div>
//     </div>
//   )
// }

import { useState } from "react";
import axios from "axios";
import "./memberflyer.css";
import flyerBg from "../Images/flyer-bg.jpeg";

export default function MemberFlyerLogin() {
  const [name,setName]=useState("")
  const [mobile,setMobile]=useState("")
  const [otp,setOtp]=useState("")
  const [showOtp,setShowOtp]=useState(false)

  const sendOtp=async()=>{
    const res=await axios.post("https://api.lbnhyderabad.com/signup/api/memberflyer/send-otp",{name,mobile})
    if(res.data.success){
      setShowOtp(true)
      alert("OTP sent")
    }
  }

  const verifyOtp=async()=>{
    const res=await axios.post("https://api.lbnhyderabad.com/signup/api/memberflyer/verify-otp",{mobile,otp})
    if(res.data.success){
      localStorage.setItem("memberflyer",JSON.stringify(res.data.user))
      window.location="/memberflyer"
    }
  }

  return(
    <div
  className="flyerBackground"
  style={{ backgroundImage: `url(${flyerBg})` }}
>

      <div className="overlay-flyer"></div>

      <div className="loginContainer">

        <div className="loginCard">

          <h1 className="title" style={{color:'#045298'}}>Member Flyer</h1>

          {!showOtp && (
          <>
          <input
          placeholder="Your Name"
          value={name}
          onChange={(e)=>setName(e.target.value)}
          />

          <input
          placeholder="WhatsApp Mobile"
          value={mobile}
          onChange={(e)=>setMobile(e.target.value)}
          />

          <button onClick={sendOtp}>Send WhatsApp OTP</button>
          </>
          )}

          {showOtp && (
          <>
          <input
          placeholder="Enter OTP"
          value={otp}
          onChange={(e)=>setOtp(e.target.value)}
          />

          <button onClick={verifyOtp}>Verify WhatsApp OTP</button>
          </>
          )}

        </div>

      </div>
    </div>
  )
}